import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { useTranslation } from '@fanfanlo';
import { useRouter } from 'next/router';
interface IMenuItemData{
    name:string
    url:string
}
export const MainPageAddButtons: React.FC = () => {
    const router = useRouter();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const {t} = useTranslation('homepage/components/markets/main-page-add-buttons/content')
    const menuItems:IMenuItemData[] = [
        {
            name:t("content.sub.addScriptByUrl"),
            url:"/listen-editing-market"
        },
        {
            name:t("content.sub.addScriptByText"),
            url:"/add-market-by-text"
        },
        {
            name:t("content.sub.addMarket"),
            url:"/add-market-by-url"
        },
        {
            name:t("content.sub.addMarketByText"),
            url:"/listen-editing-market"
        }
    ]
    return (
        <>
            <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleClick}
            >
                {t("content.add")}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {menuItems.map((item, index) => (
                    <MenuItem 
                        key={index}
                        onClick={() => {
                            handleClose();
                            router.push(item.url);
                        }}
                    >
                        {item.name}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};